import { getColumnsByNames } from './all-top10-columns-config';

export const topDetectedThreatsReportConfig = getColumnsByNames([
    { name: 'threatid' },
    { name: 'subtype' },
    { name: 'severity' },
    { name: 'application', width: '15%'},
    { name: 'count', width: '20%' }
]);